import allTechs from '../../config/all-unified-techs.json';

function getIconByPbgid(pbgid) {
    for (const entries of Object.values(allTechs)) {
        const match = entries.find(e => e.pbgid === pbgid);
        if (match) return match.icon;
    }
    return null;
}

function TechColumn({ techs }) {
    if (!techs || techs.length === 0) return <div className='flex flex-col gap-0.5 min-h-4' />;

    const icons = Object.values(techs)
        .map(pbgid => ({ pbgid: Number(pbgid), icon: getIconByPbgid(Number(pbgid)) }))
        .filter(t => t.icon);

    return (
        <div className='flex flex-col gap-0.5'>
            {icons.map(({ pbgid, icon }) => (
                <img key={pbgid} src={icon} alt='' className='w-5 h-5 object-contain' title={pbgid} />
            ))}
        </div>
    );
}

function LiveGameTechList({ gameState, label = 'Techs' }) {
    const leftTechs  = gameState?.leftPlayer?.technologies_researched;
    const rightTechs = gameState?.rightPlayer?.technologies_researched;

	console.log(rightTechs)

    return (
        <div className='grid grid-cols-3 items-start text-sm text-white w-full'>
            <div className='flex justify-end pr-2'>
                <TechColumn techs={leftTechs} />
            </div>

            <div className='flex items-start justify-center px-1 pt-0.5'>
                {label && (
                    <span className='text-[10px] font-semibold text-zinc-400 uppercase tracking-wide'>
                        {label}
                    </span>
                )}
            </div>

            <div className='flex justify-start pl-2'>
                <TechColumn techs={rightTechs} />
            </div>
        </div>
    );
}

export default LiveGameTechList;
